/*
 * THIS FILE IS INTENDED TO CONTAIN HELPER FUNCTIONS USED TO DETERMINE USER CHARACTERISTICS
 */

import type { AccountData } from '~publish/contexts/AccountContext'

export const isFreeUser = (account: AccountData | null): boolean => {
  if (!account) {
    return false
  }

  const { currentOrganization } = account

  if (currentOrganization?.billing?.__typename === 'OBBilling') {
    return currentOrganization.billing.subscription.plan.id === 'free'
  }

  return false
}

export const isEssentialsUser = (account: AccountData | null): boolean => {
  if (!account) {
    return false
  }

  const { currentOrganization } = account

  if (currentOrganization?.billing?.__typename === 'OBBilling') {
    return currentOrganization.billing.subscription.plan.id === 'essentials'
  }

  return false
}

export function isTrialUser(user: AccountData | null): boolean {
  if (!user) {
    return false
  }

  const { currentOrganization } = user

  if (currentOrganization?.billing?.__typename === 'OBBilling') {
    return !!currentOrganization.billing.subscription.trial?.isActive
  }

  return false
}

/*
 * We use this function to get the signup date of a user in milliseconds.
 * It is used over all in experiments to determine the user's signup date.
 */
export const getSignUpDateInEpochsMs = (
  account: AccountData | null,
): number => {
  const currentOrganizationCreationDate =
    account?.currentOrganization?.createdAt

  return currentOrganizationCreationDate
    ? new Date(currentOrganizationCreationDate).getTime()
    : 0
}
